import { MaybeNull } from 'interfaces'
import { AppDTO, AppFormDTO, AppInstanceDTO, AppInstanceFieldDTO } from 'interfaces/apps'

export const getAppInstanceFormValues = ({
  app,
  appInstance,
  appInstanceFields,
}: {
  app?: MaybeNull<AppDTO>
  appInstance: MaybeNull<AppInstanceDTO>
  appInstanceFields: AppInstanceFieldDTO[]
}): AppFormDTO => {
  const fields: AppFormDTO['fields'] = []

  app?.form?.forEach(formField => {
    fields.push({
      ...formField,
      value:
        /* temporarily hard coding to self hosted transponder.   */
        formField.name === 'transponderType'
          ? 'self'
          : appInstanceFields?.find(field => field.name === formField.name)?.value || '',
      migratorPurposeMapping: [],
    })
  })

  if (app?.code === 'onetrust') {
    const purposeMappingString = appInstanceFields?.[0]?.value || ''
    const purposeMapping = purposeMappingString.split(';').reduce(
      (acc, mapping) => {
        if (mapping && mapping.includes(':')) {
          const [appPurpose, ketchPurposeCodes] = mapping.split(':')
          if (appPurpose && ketchPurposeCodes) {
            acc.push({
              appPurpose,
              ketchPurposeCodes: ketchPurposeCodes.split(',').filter(Boolean),
            })
          }
        }
        return acc
      },
      [] as { appPurpose: string; ketchPurposeCodes: string[] }[],
    )

    fields[0].migratorPurposeMapping = purposeMapping
  }

  return {
    name: appInstance?.name || '',
    code: appInstance?.code || '',
    description: appInstance?.description || '',
    fields,
    identitySpaces:
      app?.identitySpaces?.map(identitySpace => ({
        name: identitySpace.name,
        code: identitySpace.code,
        managed: !!identitySpace.managed,
        filters: identitySpace?.filters?.[0],
        userIdentitySpaceCode:
          appInstance?.identitySpaceMappings?.find(
            ({ destinationIdentitySpace }) => destinationIdentitySpace === identitySpace.code,
          )?.sourceIdentitySpace || !!identitySpace.managed
            ? identitySpace.code
            : '',
      })) || [],
  }
}
